/**
 * Shared data cache utility for driver segmentation data
 * This helps maintain consistent data between pages
 */

// Global data cache for driver segmentation
export const driverSegmentationCache = {
  data: null,
  timestamp: 0,
  vehicleId: null
};

// Cache expiration time (5 minutes in milliseconds)
export const CACHE_EXPIRATION = 5 * 60 * 1000;

/**
 * Clear the driver segmentation cache
 */
export function clearDriverSegmentationCache() {
  driverSegmentationCache.data = null;
  driverSegmentationCache.timestamp = 0;
  driverSegmentationCache.vehicleId = null;
  console.log('Driver segmentation cache cleared');
}

/**
 * Store data in the driver segmentation cache
 * @param {Object} data - The data to cache
 * @param {string} vehicleId - The vehicle ID associated with the data
 */
export function storeDriverSegmentationData(data, vehicleId) {
  driverSegmentationCache.data = data;
  driverSegmentationCache.timestamp = Date.now();
  driverSegmentationCache.vehicleId = vehicleId;
}

/**
 * Check if the cache is still valid
 * @param {string} vehicleId - The vehicle ID to check against
 * @returns {boolean} - Whether the cache is valid
 */
export function isDriverSegmentationCacheValid(vehicleId) {
  const now = Date.now();
  return (
    driverSegmentationCache.data &&
    driverSegmentationCache.vehicleId === vehicleId &&
    now - driverSegmentationCache.timestamp < CACHE_EXPIRATION
  );
}

/**
 * Get data from the cache if valid, otherwise return null
 * @param {string} vehicleId - The vehicle ID to check against
 * @returns {Object|null} - The cached data or null
 */
export function getDriverSegmentationData(vehicleId) {
  if (isDriverSegmentationCacheValid(vehicleId)) {
    return driverSegmentationCache.data;
  }
  return null;
} 